module.exports = __webpack_public_path__ + "media/img/home/clients-map/baam-513f93c6d03c80355cb20e6062301d71.svg";